import React from "react";

const useEnv = () => {
  const useMainnet = !!process.env.REACT_APP_USE_MAINNET;

  return { useMainnet };
};

export default useEnv;
